import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import FormRender, { FormResourceType } from 'modules/forms/components/FormRender'
import { useLoadResponses } from 'modules/forms/hooks/useForms'
import { mapFormAnswersToSurveyAnswers } from 'modules/forms/lib/surveyAnsweringFormHelpers'

type Data = {
  formId: string
  membershipId: string
  resourceType: FormResourceType
  materializedFormResourceType: string
  closePath?: string
  respondentId?: string
}

export const FormResponsesActivity: ActivityComponent<Data> = ({
  formId,
  membershipId,
  resourceType,
  materializedFormResourceType,
  closePath,
  respondentId,
}) => {
  const navigate = useNavigate()
  const { open, closeActivity } = useActivity()

  const { form, loadingForm } = useLoadResponses({
    membershipId,
    resourceType,
    materializedFormResourceType,
    formId,
    respondentId,
  })

  const isLoading = loadingForm && !form

  const defaultValues = useMemo(() => {
    if (!form) return undefined
    return mapFormAnswersToSurveyAnswers(form)
  }, [form])

  const handleClose = () => {
    closeActivity()

    if (closePath) {
      navigate(closePath)
    }
  }

  if (isLoading) {
    return null
  }

  return (
    <FormRender
      formId={formId}
      resourceType={resourceType}
      isOpen={open}
      onClose={handleClose}
      mode="preview"
      defaultValues={defaultValues}
    />
  )
}
